import { useContext } from "react";




// custom hook importation
import { useFetchListCalls } from "../../customs-hooks/service-calls/useFetchListCalls.js";


// components importation
import { LoadingComp } from "../../components/loading-comp/LoadingComp.jsx";

// icons importation
// import { Search } from "../../components/icons/AppIcons.jsx";


// global function importation
import { renderDate } from "../../global-functions/global-functions.js";

// react translation importation
import { useTranslation } from "react-i18next";


import { LangContext } from "../../context/LangContext.jsx"





export const TrackComp = () => {


  const { state, listServ } = useFetchListCalls();

  // GET the react translation
  const [t] = useTranslation("global");

  const { lang } = useContext(LangContext);


  return (
    <>
      <div className="container">
        {
          state.isLoading && (<LoadingComp />)
        }
        {
          (state.notFound) && (<h3 style={{ color: "var(--danger-color)" }}>{state.msg}</h3>)
        }
        {
          state.dataVisible && (
            <>
              <h1 className="m-y-small">{t("NavBarComp.casos_abiertos")} ({listServ.length})</h1>

              {/* <div className="cont-btn-search">
                <button type="button" className="btn-search" onClick={handleOpenCloseFilter}>
                  <Search />
                </button>
              </div> */}

              {
                // table mobile
                window.screen.width > 990 && (
                  <div className="">

                    <table className="table">
                      <thead className="table-head">
                        <tr>
                          <th>Ticket no.</th>
                          <th>{t("NewCallComp.equipment")}</th>
                          <th>{t("NewCallComp.ingresado_por")}</th>
                          <th>{t("NewCallComp.fecha")}</th>
                          <th>{t("NewCallComp.falla")}</th>
                        </tr>
                      </thead>
                      <tbody className="table-body">
                        {
                          listServ && listServ.map((serv) => (
                            <tr key={serv.CodServicio}>
                              <td className="fake-link-2">{serv.CodServicio}</td>
                              <td>{serv.Equipo}</td>
                              <td>{serv.Nombre}</td>
                              <td>{renderDate(serv.FecIngreso, lang)}</td>
                              <td>{serv.Problema}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>

                  </div>
                )
              }

              {
                window.screen.width <= 990 && (
                  <div className="cont-mob-cards-serv-lst flex-col">
                    {
                      listServ && listServ.map((serv) => (
                        <div className="card-mobile-lst-serv" key={serv.CodServicio}>
                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>Ticket No.</strong>
                            </div>
                            <div className="col-mb-80 p-col">
                              <strong className="fake-link-2">
                                {serv.CodServicio}
                              </strong>
                            </div>
                          </div>

                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>{t("NewCallComp.equipment")}</strong>
                            </div>
                            <div className="col-mb-80 p-col">
                              <span>{serv.Equipo}</span>
                            </div>
                          </div>

                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>Status</strong>
                            </div>
                            <div className="col-mb-80 status-call-serv">
                              <span>{serv.Etapa}</span>
                            </div>
                          </div>

                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>{t("NewCallComp.ingresado_por")}</strong>
                            </div>
                            <div className="col-mb-80 p-col">
                              <span>{serv.Nombre}</span>
                            </div>
                          </div>

                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>{t("NewCallComp.falla")}</strong>
                            </div>
                            <div className="col-mb-80 p-col">
                              <span>{serv.Problema}</span>
                            </div>
                          </div>

                          <div className="row-flex">
                            <div className="col-mb-30 p-col">
                              <strong>{t("NewCallComp.fecha")}</strong>
                            </div>
                            <div className="col-mb-80 p-col">
                              <span>{renderDate(serv.FecIngreso, lang)}</span>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                )
              }
            </>
          )
        }
      </div>
    </>
  );
};